import { render, staticRenderFns } from "./ComAudio.vue?vue&type=template&id=b0a4b7ca&"
import script from "./ComAudio.vue?vue&type=script&lang=js&"
export * from "./ComAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports